import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  mode:'history',
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'home'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/PrivacyPolicy',
              name: 'software',
              component: resolve => require(['@/view/PrivacyPolicy'], resolve),
              meta: {
                title: 'PrivacyPolicy'
              }
            },
            {
              path: '/software/TermsOfUse',
              name: 'software',
              component: resolve => require(['@/view/TermsOfUse'], resolve),
              meta: {
                title: 'TermsOfUse'
              }
            }
          ]
        }, {
          path: '/Blog',
          name: 'Blog',
          component: resolve => require(['@/view/Blog'], resolve),
          meta: {
            title: 'Blog'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '新闻动态'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '公司介绍'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'ContactUs'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/TermsOfUse',
          name: 'Terms',
          component: resolve => require(['@/view/TermsOfUse'],resolve),
          meta: {
            title: 'TermsOfUse'
          }
        },
        {
          path: '/PrivacyPolicy',
          name: 'Privacy',
          component: resolve => require(['@/view/PrivacyPolicy'],resolve),
          meta: {
            title: 'PrivacyPolicy',
        },
      },
      {
        path: '/Cookies',
        name: 'Cookies',
        component: resolve => require(['@/view/Cookies'],resolve),
        meta: {
          title: 'Cookies',
      },
    },
      {
        path: '/articledetail1',
        name: 'articledetail1',
        component: resolve => require(['@/view/ArticleDetail1'],resolve),
        meta: {
          title: 'Infuse Vibrancy into Your Lifestyle with Cartoon Art'
        }
      },
        {
          path: '/articledetail2',
          name: 'articledetail2',
          component: resolve => require(['@/view/ArticleDetail2'],resolve),
          meta: {
            title: 'Celebrate the Festive Season by Cartoonizing Yourself'
          }
        },
        {
          path: '/articledetail3',
          name: 'articledetail3',
          component: resolve => require(['@/view/ArticleDetail3'],resolve),
          meta: {
            title: 'Distinguish Your Professional Image by Cartoonizing Yourself'
          }
        },
        {
          path: '/articledetail4',
          name: 'articledetail4',
          component: resolve => require(['@/view/ArticleDetail4'],resolve),
          meta: {
            title: 'Achieve Sporting Greatness by Cartoonizing Yourself'
          }
        },
        {
          path: '/Login',
          name: 'Login',
          component: resolve => require(['@/view/Login'],resolve),
          meta: {
            title: 'Login',
            showNav: true
          }
        },
        {
          path: '/SignUp',
          name: 'SignUp',
          component: resolve => require(['@/view/SignUp'],resolve),
          meta: {
            title: 'SignUp',
            showNav: true
          }
        }
      ]
    }
  ],
})




// WEBPACK FOOTER //
// ./src/router/index.js